/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S1_HeadingInputs */

const tr_cerez_s1_heading = /** @type {(inputs: Cerez_S1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Çerez Nedir?`)
};

const en_cerez_s1_heading = /** @type {(inputs: Cerez_S1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. What is a cookie?`)
};

const de_cerez_s1_heading = /** @type {(inputs: Cerez_S1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Was ist ein Cookie?`)
};

const ru_cerez_s1_heading = /** @type {(inputs: Cerez_S1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Что такое файл cookie?`)
};

/**
* | output |
* | --- |
* | "1. What is a cookie?" |
*
* @param {Cerez_S1_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s1_heading = /** @type {((inputs?: Cerez_S1_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S1_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s1_heading(inputs)
	if (locale === "de") return de_cerez_s1_heading(inputs)
	if (locale === "ru") return ru_cerez_s1_heading(inputs)
	return tr_cerez_s1_heading(inputs)
});